import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["transition", "maxWidth", "maxHeight", "style", "className", "children"],
  _excluded2 = ["name", "sticky", "width", "collapsedWidth", "barBackground", "childrenBackground", "title", "titleProps", "content", "footer", "hideBottomFrame", "className", "children"],
  _excluded3 = ["className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import DixuDivider from "../DixuDivider/DixuDivider";
import DixuText from "../DixuText/DixuText";
import DixuTitle from "../DixuTitle/DixuTitle";
import useStickyState from "../../hooks/useStickyState";
import React from 'react';
import { toRem } from "../../utils/Utils";
const DixuSidebarContent = _ref => {
  let {
      transition,
      maxWidth,
      maxHeight,
      style,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-siderbar-content', {
    [`dixu-sidebar-content--transition-${transition}`]: transition
  }, className);
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes,
    style: _objectSpread({
      maxWidth: toRem(maxWidth),
      maxHeight: toRem(maxHeight)
    }, style)
  }, rest), children);
};
DixuSidebarContent.defaultProps = {
  transition: 'fade',
  maxWidth: 256,
  maxHeight: 256
};
const DixuSidebar = _ref2 => {
  let {
      name,
      sticky,
      width,
      collapsedWidth,
      barBackground,
      childrenBackground,
      title,
      titleProps,
      content,
      footer,
      hideBottomFrame,
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const [collapsed, setCollapsed] = useStickyState({
    initialValue: null,
    defaultValue: false,
    key: `DixuSidebar_${name}_collapsed`,
    allowedValues: [false, true]
  });
  const classes = classNames('dixu-sidebar', {
    'dixu-sidebar--collapsed': collapsed
  }, className);
  if (collapsed === null) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: classNames('dixu-sidebar__bar', {
      'dixu-sidebar__bar--sticky': sticky
    }, `bg-${barBackground}`),
    style: {
      width: collapsed ? toRem(collapsedWidth) : toRem(width)
    }
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "dixu-sidebar__bar-title-wrapper",
    style: {
      width: toRem(width)
    }
  }, /*#__PURE__*/React.createElement(DixuSidebarContent, null, /*#__PURE__*/React.createElement(DixuTitle, _objectSpread({
    level: '1',
    appear: '3',
    color: '2-1',
    align: 'center',
    weight: 'bold',
    margin: '28'
  }, titleProps), title))), /*#__PURE__*/React.createElement("div", {
    className: "dixu-sidebar__bar-content"
  }, content), /*#__PURE__*/React.createElement("div", {
    className: "dixu-sidebar__bar-footer"
  }, footer, /*#__PURE__*/React.createElement("button", {
    className: "dixu-sidebar__collapse-toggle",
    type: "button",
    onClick: () => setCollapsed(!collapsed)
  }, /*#__PURE__*/React.createElement(DixuSidebarContent, {
    transition: "center"
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "4",
    color: "2-1"
  }, collapsed ? /*#__PURE__*/React.createElement(MenuUnfoldOutlined, null) : /*#__PURE__*/React.createElement(MenuFoldOutlined, null))), /*#__PURE__*/React.createElement(DixuSidebarContent, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-1",
    weight: "bold",
    className: "p-l-10"
  }, "Pienenn\xE4"))))), /*#__PURE__*/React.createElement("div", {
    className: "dixu-sidebar__children",
    style: {
      paddingRight: collapsed ? toRem(collapsedWidth) : toRem(width)
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('dixu-sidebar__children-frame', 'dixu-sidebar__children-frame--top', `bg-${barBackground}`)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('dixu-sidebar__children-frame-background', 'dixu-sidebar__children-frame-background--top', `bg-${childrenBackground}`)
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames('dixu-sidebar__children-content')
  }, /*#__PURE__*/React.createElement("div", {
    className: "dixu-sidebar__children-wrapper"
  }, children)), /*#__PURE__*/React.createElement("div", {
    className: classNames('dixu-sidebar__children-frame', 'dixu-sidebar__children-frame--bottom', `bg-${barBackground}`, {
      'dixu-sidebar__children-frame--hidden': hideBottomFrame
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('dixu-sidebar__children-frame-background', 'dixu-sidebar__children-frame-background--bottom', `bg-${childrenBackground}`)
  }))));
};
DixuSidebar.defaultProps = {
  name: 'main',
  sticky: true,
  width: 260,
  collapsedWidth: 64,
  barBackground: '2-9',
  childrenBackground: '2-2',
  title: undefined,
  titleProps: undefined,
  content: undefined,
  footer: undefined,
  hideBottomFrame: false
};
const DixuSidebarDivider = _ref3 => {
  let {
      className
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  const classes = classNames('dixu-sidebar-divider', className);
  return /*#__PURE__*/React.createElement(DixuDivider, _objectSpread({
    className: classes,
    color: '2-8'
  }, rest));
};
DixuSidebar.Content = DixuSidebarContent;
DixuSidebar.Divider = DixuSidebarDivider;
export default DixuSidebar;